
















































































































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { OfferService } from '@/data/services/offer.service';
import { date2Num, dateEndofDay } from '@/data/utils/helper';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { User } from '@/data/models/user.model';
import store, { State } from '@/store';
import { FattorinoStats } from '@/data/models/offer.model';

@Component({
	components: {
		ValidationObserver,
		ValidationProvider,
	},
})
export default class FattorinoStatsList extends Vue {
    @Prop() fattorino!: User;
    
	@Inject('OfferService') offerService!: OfferService;

	rangeStats: Date[] = [];
	loading: boolean = false;

	rows: FattorinoStats[] = [];

	state!: State;
	
	constructor() {
		super();
		this.state = store;
	}

	loadStats() {
		this.loading = true;
		const start = Math.round(this.rangeStats[0].getTime() / 1000);
		const stop = Math.round(dateEndofDay(this.rangeStats[1]).getTime() / 1000);
		this.offerService.statsFattorino(this.fattorino.id, start, stop) .then(response => {
			this.rows = response;
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		}).finally(() => this.loading = false);
	}

	undo(row: FattorinoStats) {
		const loading = this.$buefy.loading.open({});
		this.offerService.annullaScarico(this.fattorino.id, date2Num(row.date) as number).then(() => {
			this.$buefy.notification.open({
				message: this.$t('success-save') as string,
				type: 'is-success',
			});
			this.loadStats();
		}).catch(({ data }) => {
			this.$buefy.notification.open({
				message: data.msg || data.internal,
				type: 'is-danger',
			});
		}).finally(() => loading.close());
	}

}
